import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=a145312e&scoped=true&"
import script from "./KModal.vue?vue&type=script&lang=js&"
export * from "./KModal.vue?vue&type=script&lang=js&"
import style0 from "./KModal.vue?vue&type=style&index=0&id=a145312e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a145312e",
  null
  
)

export default component.exports